import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Super Admin business switcher: send the impersonation header on every
  // authenticated call so backend `require_business` scopes to the chosen
  // business. Backend silently ignores it for non-admin users — safe to
  // attach unconditionally.
  const adminBizId = localStorage.getItem("kp_admin_biz_id");
  if (adminBizId) config.headers["X-Admin-Business-ID"] = adminBizId;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (!path.startsWith("/logg-inn") && !path.startsWith("/book") && path !== "/") {
        localStorage.removeItem("kp_token");
        localStorage.removeItem("kp_user");
      }
    }
    return Promise.reject(err);
  }
);

export const formatNOK = (n) =>
  new Intl.NumberFormat("nb-NO", { style: "currency", currency: "NOK", maximumFractionDigits: 0 }).format(n || 0);

export const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("nb-NO", { day: "2-digit", month: "short", year: "numeric" }) : "";

export const formatDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("nb-NO", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "";

export const formatTime = (iso) =>
  iso ? new Date(iso).toLocaleTimeString("nb-NO", { hour: "2-digit", minute: "2-digit" }) : "";

export const DAY_NAMES = ["Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag", "Søndag"];
export const DAY_SHORT = ["Man", "Tir", "Ons", "Tor", "Fre", "Lør", "Søn"];
